<template >
  <div class="form-group formio-component formio-component-fieldset formio-component-fieldset  formio-component-label-hidden" :class="ctx.customClass"
    :id="ctx.key">
      <fieldset>
        <legend class="" ref="header">{{ctx.legend}}</legend>
        <div ref="nested-fieldset" class="fieldset-body">
            <template v-for="component in ctx.components">
                <component
                    :is="component.type"
                    :key="component.key"
                    :theme="theme"
                    :ctx-a="component"
                    :store="store"
                ></component>
            </template>
        </div>
      </fieldset>
        <div class="formio-errors invalid-feedback" ref="messageContainer"></div>
  </div>
</template>

<script>
import SimpleComponentMixin from '../../mixins/SimpleComponentMixin';
import defaultSchema from './fieldsetDefaultSchema';

// TODO: Add a better key for v-for
export default {
  name: 'fieldsets',
  mixins: [SimpleComponentMixin],
  beforeCreate() {
    this.defaultSchema = defaultSchema;
  }
};
</script>
